export const SET_ITEMS = 'SET_ITEMS';
export const SET_TOTAL = 'SET_TOTAL';
export const SET_CRITERE_RECHERCHE = 'SET_CRITERE_RECHERCHE';
export const SET_BRIEF = 'SET_BRIEF';
export const SET_PANIER = 'SET_PANIER';
export const ADD_LIGNE_IN_PANIER = 'ADD_LIGNE_IN_PANIER';
export const DELETE_LIGNE_IN_PANIER = 'DELETE_LIGNE_IN_PANIER';
export const SET_LIGNES_COMMANDE = 'SET_LIGNES_COMMANDE';
export const CLEAR_LIGNES_COMMANDE = 'CLEAR_LIGNES_COMMANDE';
export const CLEAR_PANIER = 'CLEAR_PANIER';
export const SET_IS_FROM_LIST_RESEAU_TEMPO_DISPO = 'SET_IS_FROM_LIST_RESEAU_TEMPO_DISPO';
export const SET_LAST_PAYLOAD = 'SET_LAST_PAYLOAD';
